var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevel2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7271 10.084C22.5931 9.63549 23.7623 6.90988 22.4231 4.85541C20.7033 2.22226 16.244 3.39331 16.244 3.39331C16.244 3.39331 15.0884 0 11.6114 0C8.1344 0 6.89723 3.35907 6.89723 3.35907C6.89723 3.35907 2.34618 1.63673 0.487021 4.81774C-0.801138 7.02288 0.687551 9.41634 2.37677 9.87517C2.66907 9.95393 2.85941 10.2313 2.83222 10.5326L2.12526 18.2472C2.08787 18.6512 2.24762 19.045 2.55691 19.3018C3.61055 20.1749 6.40439 22 11.3701 22C16.3358 22 19.4661 20.0928 20.6557 19.1922C21.0024 18.9286 21.1791 18.5005 21.1282 18.0691L20.2648 10.7586C20.2275 10.4504 20.4246 10.1594 20.7271 10.084ZM11.6284 17.689C10.0615 17.689 8.79038 16.4084 8.79038 14.8299C8.79038 13.2514 10.0615 11.9707 11.6284 11.9707C13.1953 11.9707 14.463 13.2514 14.463 14.8299C14.463 16.4084 13.1953 17.689 11.6284 17.689Z",
    fill: "#F49227"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel2);
export default __webpack_public_path__ + "static/media/level2.513ed4c3f2ec500bc9a159d87434e54f.svg";
export { ForwardRef as ReactComponent };